<template>
  <v-app-bar app class="px-8 navbar" color="transparent" dark flat elevate-on-scroll>

    <!-- <v-spacer></v-spacer> -->
    <v-btn text class="nav-btn" @click="scroll('intro')">About me</v-btn>
    <v-btn text class="nav-btn" @click="scroll('quote')">Quotes</v-btn>
    <v-btn text class="nav-btn" @click="scroll('learnings')">Interests</v-btn>
    <v-btn text class="nav-btn" @click="scroll('work')">Portfolio</v-btn>
    <v-btn text class="nav-btn" @click="scroll('blog')">Blogs</v-btn>
    <v-btn text class="nav-btn" @click="scroll('contact')"> Connect</v-btn>
  </v-app-bar>
</template>

<script>
export default {
  methods: {
    scroll(refName) {
      const element = document.getElementById(refName);
      element.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style>
* {
  font-style: inherit;
  font-family: inherit;
}
.v-toolbar__content{
  display: flex;
  margin: 0; /*this will remove the empty spaces/margins coming around */
  padding: 0;
  justify-content: center;
}
.navbar {
  background: rgba(18,18,18,0.5) !important;
  backdrop-filter: saturate(150%) blur(10px);
}
.nav-btn {
  text-transform: none;
  letter-spacing: 0.2px;
  font-weight: 500;
}
.nav-btn:hover {
  color: #8ab4f8 !important;
}
</style>